import { Button, Card as AntCard, Typography } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import { Breakpoints } from 'logic/hooks/use-breakpoints';
import React from 'react';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { colors } from 'styles/colors';

export const Heading = styled(Typography.Title)`
  &.ant-typography {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0;
  }
`;

export const MainHeading = styled(Typography.Title)`
  &.ant-typography {
    font-size: 26px;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 0;
    word-break: break-word;
  }
`;

export const UserImagePreview = styled(({ large, ...rest }) => <Avatar {...rest} />)`
  height: ${({ large }) => `${large ? 160 : 100}px`};
  width: ${({ large }) => `${large ? 160 : 100}px`};
  margin-bottom: ${({ large }) => !large && '40px'};
  margin-right: ${({ large }) => large && '40px'};
  flex-shrink: 0;
`;

export const Preview = styled(Typography.Text)`
  &.ant-typography {
    display: block;
    margin-top: 10px;
    @media (${Breakpoints.maxMobileLarge}) {
      width: 300px;
    }
  }
`;

export const Separator = styled.div`
  background-color: ${({ color }) => (color ? color : colors.gray6)};
  height: 1px;
  margin: 30px 0;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ActionButton = styled(Button)`
  &.ant-btn-link {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.3;

    @media (${Breakpoints.min400}) {
      margin-top: -8px;
      font-size: 18px;
    }
  }
`;

export const useProfileHeadingStyles = () => {
  const { min400 } = useBreakpoints();
  const fontSize = min400 ? 18 : 14;

  return { fontSize };
};

export const ProfileHeading: React.FC = ({ children }) => {
  const { fontSize } = useProfileHeadingStyles();

  return <Heading style={{ fontSize }}>{children}</Heading>;
};

export const Card = styled(AntCard).attrs({ bordered: false })`
  margin: 20px 0;
`;

export const UserProfileButtons = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 0 20px 0;
`;
